import Carousel from "./Carousel";
import Image from "./Image";
import Video from "./Video";

export { Carousel, Image, Video }

export default Carousel;
